<template>
  <dropdown ref="dropdown" label="Filter" :relative="relative" @open="scrollDropdownIntoView">
    <template slot="icon">
      <icon-base icon-name="Filter" width="25" height="25">
        <icon-filter />
      </icon-base>
    </template>
    <template slot="content">
      <product-filters @filtered="closeDropdown" @accordionOpened="scrollDropdownIntoView"></product-filters>
    </template>
  </dropdown>
</template>

<script>
import Dropdown from '@/components/Dropdown'
import IconBase from '@/components/IconBase'
import IconFilter from '@/components/icons/IconFilter'
import ProductFilters from '@/components/ProductFilters'

export default {
  components: {
    Dropdown,
    IconBase,
    IconFilter,
    ProductFilters
  },

  data: function () {
    return {
      relative: true
    }
  },

  created () {
    this.onResize()
    window.addEventListener('resize', this.onResize)
  },

  beforeDestroy () {
    window.removeEventListener('resize', this.onResize)
  },

  methods: {
    onResize () {
      if (window.innerWidth > 600) {
        this.relative = true
      } else {
        this.relative = false
      }
    },
    closeDropdown () {
      this.$refs.dropdown.close()
    },
    scrollDropdownIntoView () {
      if (window.innerWidth < 600) {
        window.scrollBy({
          top: this.$refs.dropdown.$el.getBoundingClientRect().y - 15,
          behavior: 'smooth'
        })
      }
    }
  }
}
</script>
